/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BulkUpdateResourceObjectsRequest,
  CreateResourceObjectsRequest,
  GetResourceObjectParams,
  GetResourceObjectsByResourceIdParams,
  ResourceObjectDto,
  ResourceObjectDtoPagination,
  ResourceObjectPageRequest,
  UpdateResourceObjectRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPaginatedResourceObjectsUrl = () => {




  return `/api/ResourceObject/GetPaginatedResourceObjects`
}

export const getPaginatedResourceObjects = async (resourceObjectPageRequest?: ResourceObjectPageRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectDtoPagination> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectDtoPagination>(getGetPaginatedResourceObjectsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resourceObjectPageRequest)
  }
);}





export const getGetPaginatedResourceObjectsMutationKey = () => ['getPaginatedResourceObjects'] as const;

export const getGetPaginatedResourceObjectsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResourceObjects>>, TError,GetPaginatedResourceObjectsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResourceObjects>>, TError,GetPaginatedResourceObjectsMutationVariables, TContext> => {

const mutationKey = getGetPaginatedResourceObjectsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedResourceObjects>>, GetPaginatedResourceObjectsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedResourceObjects(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedResourceObjectsMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedResourceObjects>>>
    export type GetPaginatedResourceObjectsMutationBody = BodyType<ResourceObjectPageRequest> | undefined
    export type GetPaginatedResourceObjectsMutationError = ErrorType<unknown>
    export type GetPaginatedResourceObjectsMutationVariables = {data?: BodyType<ResourceObjectPageRequest>}

    export const useGetPaginatedResourceObjects = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResourceObjects>>, TError,GetPaginatedResourceObjectsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedResourceObjects>>,
        TError,
        GetPaginatedResourceObjectsMutationVariables,
        TContext
      > => {
      return useMutation(getGetPaginatedResourceObjectsMutationOptions(options), queryClient);
    }
    export const getGetResourceObjectsByResourceIdUrl = (params?: GetResourceObjectsByResourceIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceObject/GetResourceObjectsByResourceId?${stringifiedParams}` : `/api/ResourceObject/GetResourceObjectsByResourceId`
}

export const getResourceObjectsByResourceId = async (params?: GetResourceObjectsByResourceIdParams, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectDto[]> => {

  return customInstance<ResourceObjectDto[]>(getGetResourceObjectsByResourceIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResourceObjectsByResourceIdQueryKey = (params?: GetResourceObjectsByResourceIdParams,) => {
    return [
    `/api/ResourceObject/GetResourceObjectsByResourceId`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResourceObjectsByResourceIdQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectsByResourceIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>> = ({ signal }) => getResourceObjectsByResourceId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourceObjectsByResourceIdQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>>
export type GetResourceObjectsByResourceIdQueryError = ErrorType<unknown>


export function useGetResourceObjectsByResourceId<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectsByResourceIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectsByResourceId>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectsByResourceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectsByResourceId<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectsByResourceId>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectsByResourceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectsByResourceId<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObjectsByResourceId<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectsByResourceIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResourceObjectsByResourceIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectsByResourceIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>> = ({ signal }) => getResourceObjectsByResourceId(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetResourceObjectsByResourceIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>>
export type GetResourceObjectsByResourceIdSuspenseQueryError = ErrorType<unknown>


export function useGetResourceObjectsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectsByResourceIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObjectsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectsByResourceIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResourceObjectUrl = (params?: GetResourceObjectParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceObject/GetResourceObject?${stringifiedParams}` : `/api/ResourceObject/GetResourceObject`
}

export const getResourceObject = async (params?: GetResourceObjectParams, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectDto> => {

  return customInstance<ResourceObjectDto>(getGetResourceObjectUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResourceObjectQueryKey = (params?: GetResourceObjectParams,) => {
    return [
    `/api/ResourceObject/GetResourceObject`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResourceObjectQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(params?: GetResourceObjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObject>>> = ({ signal }) => getResourceObject(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourceObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObject>>>
export type GetResourceObjectQueryError = ErrorType<unknown>


export function useGetResourceObject<TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObject>>,
          TError,
          Awaited<ReturnType<typeof getResourceObject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObject<TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObject>>,
          TError,
          Awaited<ReturnType<typeof getResourceObject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObject<TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObject<TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResourceObjectSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(params?: GetResourceObjectParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObject>>> = ({ signal }) => getResourceObject(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetResourceObjectSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObject>>>
export type GetResourceObjectSuspenseQueryError = ErrorType<unknown>


export function useGetResourceObjectSuspense<TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectSuspense<TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectSuspense<TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObjectSuspense<TData = Awaited<ReturnType<typeof getResourceObject>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateResourceObjectUrl = () => {




  return `/api/ResourceObject/UpdateResourceObject`
}

export const updateResourceObject = async (updateResourceObjectRequest: UpdateResourceObjectRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectDto>(getUpdateResourceObjectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateResourceObjectRequest)
  }
);}





export const getUpdateResourceObjectMutationKey = () => ['updateResourceObject'] as const;

export const getUpdateResourceObjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceObject>>, TError,UpdateResourceObjectMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateResourceObject>>, TError,UpdateResourceObjectMutationVariables, TContext> => {

const mutationKey = getUpdateResourceObjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateResourceObject>>, UpdateResourceObjectMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateResourceObject(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateResourceObjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateResourceObject>>>
    export type UpdateResourceObjectMutationBody = BodyType<UpdateResourceObjectRequest>
    export type UpdateResourceObjectMutationError = ErrorType<unknown>
    export type UpdateResourceObjectMutationVariables = {data: BodyType<UpdateResourceObjectRequest>}

    export const useUpdateResourceObject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceObject>>, TError,UpdateResourceObjectMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateResourceObject>>,
        TError,
        UpdateResourceObjectMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateResourceObjectMutationOptions(options), queryClient);
    }
    export const getCreateResourceObjectsUrl = () => {




  return `/api/ResourceObject/CreateResourceObjects`
}

export const createResourceObjects = async (createResourceObjectsRequest: CreateResourceObjectsRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectDto[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectDto[]>(getCreateResourceObjectsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createResourceObjectsRequest)
  }
);}





export const getCreateResourceObjectsMutationKey = () => ['createResourceObjects'] as const;

export const getCreateResourceObjectsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceObjects>>, TError,CreateResourceObjectsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createResourceObjects>>, TError,CreateResourceObjectsMutationVariables, TContext> => {

const mutationKey = getCreateResourceObjectsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResourceObjects>>, CreateResourceObjectsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createResourceObjects(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResourceObjectsMutationResult = NonNullable<Awaited<ReturnType<typeof createResourceObjects>>>
    export type CreateResourceObjectsMutationBody = BodyType<CreateResourceObjectsRequest>
    export type CreateResourceObjectsMutationError = ErrorType<unknown>
    export type CreateResourceObjectsMutationVariables = {data: BodyType<CreateResourceObjectsRequest>}

    export const useCreateResourceObjects = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceObjects>>, TError,CreateResourceObjectsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createResourceObjects>>,
        TError,
        CreateResourceObjectsMutationVariables,
        TContext
      > => {
      return useMutation(getCreateResourceObjectsMutationOptions(options), queryClient);
    }
    export const getBulkUpdateResourceObjectsUrl = () => {




  return `/api/ResourceObject/BulkUpdateResourceObjects`
}

export const bulkUpdateResourceObjects = async (bulkUpdateResourceObjectsRequest: BulkUpdateResourceObjectsRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectDto[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectDto[]>(getBulkUpdateResourceObjectsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkUpdateResourceObjectsRequest)
  }
);}





export const getBulkUpdateResourceObjectsMutationKey = () => ['bulkUpdateResourceObjects'] as const;

export const getBulkUpdateResourceObjectsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateResourceObjects>>, TError,BulkUpdateResourceObjectsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateResourceObjects>>, TError,BulkUpdateResourceObjectsMutationVariables, TContext> => {

const mutationKey = getBulkUpdateResourceObjectsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateResourceObjects>>, BulkUpdateResourceObjectsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkUpdateResourceObjects(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateResourceObjectsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateResourceObjects>>>
    export type BulkUpdateResourceObjectsMutationBody = BodyType<BulkUpdateResourceObjectsRequest>
    export type BulkUpdateResourceObjectsMutationError = ErrorType<unknown>
    export type BulkUpdateResourceObjectsMutationVariables = {data: BodyType<BulkUpdateResourceObjectsRequest>}

    export const useBulkUpdateResourceObjects = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateResourceObjects>>, TError,BulkUpdateResourceObjectsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateResourceObjects>>,
        TError,
        BulkUpdateResourceObjectsMutationVariables,
        TContext
      > => {
      return useMutation(getBulkUpdateResourceObjectsMutationOptions(options), queryClient);
    }
